import { makeStyles } from "tss-react/mui";

export const useWelcomeSectionStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",    
    flexDirection: "column",
    alignSelf: "stretch",
    alignItems: "center",    
    gap: 0, // spacing now handled by marginBottom
  },
  logoContainer: {
    display: 'flex', 
    justifyContent: "center", 
    alignItems: "center",
    gap: theme.spacing(),
    marginBottom: theme.spacing(5), // 🔹 fixed spacing
    "@media(min-width: 1536px)": {  
      marginBottom: theme.spacing(6),
    },
    "@media(min-width: 1920px)": { 
      marginBottom: 62,
    },
  }, 
  logoImage: {
    width: "50px",
    height: "42px",
  },
  logoText: {
    fontSize: "34px", 
    fontWeight: 500, 
    color: "var(--color-neutral-white)",
    lineHeight: "110%",
    letterSpacing: "0%",
  },
  heading: {
    fontWeight: 400,
    fontSize: "36px",
    lineHeight: "52px",    
    textAlign: "center",
    color: "var(--color-neutral-white)",
    marginBottom: "40px", // 🔹 fixed spacing
    "@media(min-width: 1536px)": {  
      marginBottom: theme.spacing(10),
    },
    "@media(min-width: 1920px)": { 
      marginBottom: 109,
    },
  },
  description: {    
    fontWeight: 400,
    fontSize: "18px",
    lineHeight: "29.12px",
    letterSpacing: "0%",
    textAlign: "center",
    color: "var(--color-neutral-600)",
    marginBottom:  theme.spacing(3), // 🔹 fixed spacing
  },
  actions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center", 
  },
  learnmorebutton: {
    width: "19.5625rem !important",
    height: "3.75rem !important",
    padding: "1rem 1.5rem !important",
    gap: "0.25rem",
    borderRadius: "100px !important",
    fontSize: "1.125rem !important",
    fontWeight: 500,
    lineHeight: "115% !important",
    boxShadow: "0px 8px 16px 0px rgba(0, 0, 0, 0.20), 0px 4px 8px 0px rgba(0, 0, 0, 0.20) !important",
    "@media(min-width: 1920px)": {
      width: "22.875rem !important",
      height: "4.375rem !important",
    }
  }
}));
